import { useFormik } from 'formik';

import TextInput from '../Forms/TextInput';
import CommonAccountFormButtons from './CommonAccountFormButtons';
import {
  passwordInitialValues,
  passwordSchema,
} from './PasswordTab/passwordFormValues';

import { useAppDispatch } from '../../App/redux/store';
import { passwordChangeThunk } from '../../features/auth/services/authThunks';
import './PasswordTab/passwordTab.scss';

const PasswordTab = () => {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: passwordInitialValues,
    validationSchema: passwordSchema,
    onSubmit: () => {
      dispatch(
        passwordChangeThunk({
          oldPwd: values.lastPassword,
          newPwd: values.newPassword,
        }),
      );
    },
  });

  const { values, touched, errors } = formik;

  return (
    <section className="my-account-content user-password">
      <h2>Mot de passe</h2>
      <form>
        <div className="user-password-form-elt">
          <TextInput
            label="Mot de passe actuel"
            type="password"
            name="lastPassword"
            value={values.lastPassword}
            handleChange={formik.handleChange}
            error={touched.lastPassword && Boolean(errors.lastPassword)}
            helperText={touched.lastPassword && errors.lastPassword}
          />
        </div>
        <div className="user-password-form-elt">
          <TextInput
            label="Nouveau mot de passe"
            type="password"
            name="newPassword"
            value={values.newPassword}
            handleChange={formik.handleChange}
            error={touched.newPassword && Boolean(errors.newPassword)}
            helperText={touched.newPassword && errors.newPassword}
          />
          <TextInput
            label="Confirmer le nouveau mot de passe"
            type="password"
            name="newPasswordCheck"
            value={values.newPasswordCheck}
            handleChange={formik.handleChange}
            error={touched.newPasswordCheck && Boolean(errors.newPasswordCheck)}
            helperText={touched.newPasswordCheck && errors.newPasswordCheck}
          />
        </div>
        <CommonAccountFormButtons
          label="METTRE A JOUR LE NOUVEAU MOT DE PASSE"
          handleSubmit={formik.handleSubmit}
        />
      </form>
    </section>
  );
};

export default PasswordTab;
